module.exports = __webpack_public_path__ + "img/armor-icon-y.4091cbd3.png";